import Armour from './armour'

export default Armour;
export { Armour };